import { Component, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'shared-ui-inputs-base-input-field',
  template: '',
  standalone: false,
})
export abstract class BaseInputFieldComponent implements OnChanges {
  public get control(): FormControl {
    return this.parentFormGroup.get(this.formName) as FormControl;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public set control(value: any) {
    this.control.setValue(value);
  }

  @Input() parentFormGroup!: FormGroup;
  @Input() name = '';
  @Input() formName!: string;
  @Input() tabIndex!: number;
  @Input() disabled = false;

  ngOnChanges(): void {
    if (this.disabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
